import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import constants from "../../constants";
import http from "../http";
var SUBMISSION_ENDPOINT = "".concat(constants.API_URL, "/submissions");
var SUBMISSION_ENDPOINT_V1 = "".concat(constants.API_URL_V1, "/submissions");

function updateSubmission(_x) {
  return _updateSubmission.apply(this, arguments);
}

function _updateSubmission() {
  _updateSubmission = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var submissionId, data, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            submissionId = _ref.submissionId, data = _ref.data;
            _context2.next = 3;
            return http.patch("".concat(SUBMISSION_ENDPOINT_V1, "/").concat(submissionId), data);

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _updateSubmission.apply(this, arguments);
}

function getSubmission(_x2) {
  return _getSubmission.apply(this, arguments);
}

function _getSubmission() {
  _getSubmission = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
    var submissionId, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            submissionId = _ref2.submissionId;
            _context3.next = 3;
            return http.get("".concat(SUBMISSION_ENDPOINT, "/").concat(submissionId));

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getSubmission.apply(this, arguments);
}

function submitSubmission(_x3) {
  return _submitSubmission.apply(this, arguments);
}

function _submitSubmission() {
  _submitSubmission = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref3) {
    var submissionId, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            submissionId = _ref3.submissionId;
            _context4.next = 3;
            return http.post("".concat(SUBMISSION_ENDPOINT, "/").concat(submissionId, "/submit"));

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _submitSubmission.apply(this, arguments);
}

var updateSubmissionGrade = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
    var submissionId, data, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            submissionId = _ref4.submissionId, data = _ref4.data;
            _context.next = 3;
            return http.post("".concat(SUBMISSION_ENDPOINT, "/").concat(submissionId, "/grade"), data);

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function updateSubmissionGrade(_x4) {
    return _ref5.apply(this, arguments);
  };
}();

function removeAttachments(_x5) {
  return _removeAttachments.apply(this, arguments);
}

function _removeAttachments() {
  _removeAttachments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref6) {
    var submissionId, questionId, data, response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            submissionId = _ref6.submissionId, questionId = _ref6.questionId, data = _ref6.data;
            _context5.next = 3;
            return http.post("".concat(SUBMISSION_ENDPOINT, "/").concat(submissionId, "/questions/").concat(questionId, "/delete-attachments"), data);

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _removeAttachments.apply(this, arguments);
}

function addAttachments(_x6) {
  return _addAttachments.apply(this, arguments);
}

function _addAttachments() {
  _addAttachments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref7) {
    var submissionId, questionId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            submissionId = _ref7.submissionId, questionId = _ref7.questionId, data = _ref7.data, onUploadProgress = _ref7.onUploadProgress;
            _context6.next = 3;
            return http.post("".concat(SUBMISSION_ENDPOINT, "/").concat(submissionId, "/questions/").concat(questionId, "/attachments"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _addAttachments.apply(this, arguments);
}

function addSubmissionAttachmentAnnotations(_x7) {
  return _addSubmissionAttachmentAnnotations.apply(this, arguments);
}

function _addSubmissionAttachmentAnnotations() {
  _addSubmissionAttachmentAnnotations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref8) {
    var submissionId, questionId, data;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            submissionId = _ref8.submissionId, questionId = _ref8.questionId, data = _ref8.data;
            return _context7.abrupt("return", http.post("".concat(SUBMISSION_ENDPOINT, "/").concat(submissionId, "/questions/").concat(questionId, "/attachments/annotations"), data));

          case 2:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _addSubmissionAttachmentAnnotations.apply(this, arguments);
}

export default {
  updateSubmission: updateSubmission,
  getSubmission: getSubmission,
  submitSubmission: submitSubmission,
  updateSubmissionGrade: updateSubmissionGrade,
  addAttachments: addAttachments,
  removeAttachments: removeAttachments,
  addSubmissionAttachmentAnnotations: addSubmissionAttachmentAnnotations
};